import { AccessLevel, ProtectedFeature } from '@permissions/models/permissions.models';

export const protectedHighlights: ProtectedFeature[] = [
  {
    feature: 'view_highlight_grid',
    allow: [AccessLevel.Administrator, AccessLevel.Superviser, AccessLevel.Operator, AccessLevel.View],
  },
];
